import { SEPERATOR_CHAR_COUNT } from '../../data/const.esm.js';

var separatorMatcher = (() => {
  return SEPERATOR_CHAR_COUNT;
});

export { separatorMatcher as default };
//# sourceMappingURL=scoring.esm.js.map
